import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    fontFamily: 'Poppins',
    backgroundColor: '#fff',
    color: '#4d4d4c',
    fontSize: 12,
    padding: 20,
    lineHeight: 1.5,
    flexDirection: 'column'
  },
  logo: {
    marginBottom: 10,
    alignSelf: 'flex-end',
    width: 60,
    height: 52
  },
  qrcode: {
    width: 94,
    height: 94
  },
  title: {
    color: '#329d9c',
    fontWeight: 'bold',
    fontSize: 14,
    marginBottom: 20,
    textAlign: 'center'
  },
  subtitle: {
    textAlign: 'center',
    fontWeight: 500,
    marginBottom: 20
  },
  table: { marginBottom: 20, textAlign: 'left' },
  section: {
    paddingLeft: 50,
    paddingRight: 50,
    marginBottom: 40
  },
  body: {
    width: '100%',
    marginLeft: '-10px',
    marginRight: '-10px',
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderTop: '1px solid #d5d9e7'
  },
  head: {
    width: '100%',
    marginLeft: '-10px',
    marginRight: '-10px',
    flexDirection: 'row',
    flexWrap: 'wrap',
    textAlign: 'left',
    fontWeight: 500
  },
  headcell: {
    width: '20%',
    padding: '10px',
    flexGrow: 1,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    color: '#4d4d4c'
  },
  cell: {
    width: '20%',
    padding: '10px',
    flexGrow: 1,
    fontWeight: 400,
    whiteSpace: 'nowrap',
    color: '#58667e'
  },
  footer: {
    position: 'absolute',
    width: '100%',
    bottom: 20,
    left: 20,
    right: 20
  },
  icon: {
    width: 19,
    height: 18,
    lineHeight: '18px',
    marginRight: 10
  },
  link: {
    display: 'flex',
    fontWeight: 400,
    color: '#329d9c',
    fontSize: 12,
    textDecoration: 'none'
  },
  text: {
    flexDirection: 'column',
    flex: 1
  },
  textline: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: 12,
    color: '#58667e'
  },
  pagination: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    fontSize: 12,
    alignItems: 'center',
    fontWeight: 600,
    color: '#58667e'
  }
});

export default styles;
